import { Translations } from '@vi-iot/client';

import { ViCareChangeLog } from './changelog.model';

export function getViCareUpdates(
  translations: Translations,
  viCarePlatformKey: string
): ViCareChangeLog[] {
  const translationKeys: string[] = getViCareTranslationKeys(translations, viCarePlatformKey);
  const sortedTranslationKeys: string[] = sortTranslationKeysByVersion(translationKeys);

  return sortedTranslationKeys.map((key) => {
    const translation = translations[key];

    return {
      version: getUpdateVersion(key, viCarePlatformKey),
      improvements: getImprovements(translation, key),
      fixes: getFixes(translation, key),
    };
  });
}

function getViCareTranslationKeys(translations: Translations, viCarePlatformKey: string): string[] {
  const translationKeys: string[] = Object.keys(translations).filter((key) =>
    key.startsWith(viCarePlatformKey)
  );

  return translationKeys;
}

function sortTranslationKeysByVersion(translationKeys: string[]): string[] {
  // Sort updates from newest to oldest
  const sortedTranslationKeys = translationKeys.sort((a, b) =>
    a.localeCompare(b, undefined, {
      numeric: true,
      sensitivity: 'base',
    })
  );

  return sortedTranslationKeys.reverse();
}

function getUpdateVersion(translationKey: string, viCarePlatformKey: string): string {
  return translationKey.split(viCarePlatformKey)[1];
}

function getImprovements(translation: string, key: string): string[] {
  // key means improvement if it ends in .0
  // e.g. alerts_release_notes_payload_ios_2.9.0
  if (key.endsWith('.0')) {
    // Split translation by new line
    const improvements: string[] = translation.split(/\n/);

    // Removes the '- ' from the beginning of each translation
    return improvements.map((improvement) => {
      return improvement.substring(2);
    });
  }
}

function getFixes(translation: string, key: string): string[] {
  // key means fix if it does not end in .0
  // e.g. alerts_release_notes_payload_android_3.0.1
  if (!key.endsWith('.0')) {
    // Split translation by new line
    const fixes: string[] = translation.split(/\n/);

    // Removes the '- ' from the beginning of each translation
    return fixes.map((fix) => {
      return fix.substring(2);
    });
  }
}
